module.exports = __webpack_public_path__ + "static/media/Trash-hover.b9099086.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Trash-hover.svg
// module id = 5305
// module chunks = 11